export default __webpack_public_path__ + "static/media/blog-img.754c27e7.png";